/* eslint-disable @ngrx/avoid-dispatching-multiple-actions-sequentially */
import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FilterKeywords } from '@common/components/filter/filter-keywords';
import { ModalService } from '@common/components/modal/modal.service';
import { Path } from '@common/data-models/complex-types/path';
import { DataStore } from '@common/data-models/data-store/data-store';
/// <reference path="../../../../node_modules/@types/file-saver/index.d.ts" />
import { ErrorTypes } from '@common/data-models/misc/errors';
import { Record } from '@common/data-models/records/record';
import { ResultGroupStaticServices } from '@common/data-models/search-results/result-group';
import { HelloResults } from '@common/data-models/service/hello-results';
import { ObjectProperties } from '@common/data-models/service/object-properties';
import { ServiceCollectionRecord } from '@common/data-models/service/service-collection-record';
import { ServiceResponse } from '@common/data-models/service/service-response';
import { NAVIGATION_STORAGE_KEY } from '@common/enums/constants';
import { ObjectTypes } from '@common/enums/object-types';
import { ILogonService } from '@common/interfaces/i-logon-service';
import { INomWebServicesJson } from '@common/interfaces/i-nom-web-services-json';
import { Util } from '@common/utils/util';
import { Store } from '@ngrx/store';
import { environment } from '@src/environments/environment';
import { DiscoverSecurityPrivs } from '@src/suite/common/data-models/service/discover-security-privs';
import { AssignmentRecordActions, PublicationRecordActions, RundownRecordActions, StoriesRecordActions, TopicRecordActions } from '@src/suite/common/store/records/records.actions';
import { initializeRecord } from '@src/suite/common/utils/record-utils';
import { jwtDecode } from 'jwt-decode';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';

import { Convertor } from './convertor';
import { LanguageSettings } from './language-settings';

@Injectable({ providedIn: 'root' })
export class NomWebServicesJson implements INomWebServicesJson {
    private store = inject(Store);
    public logonService: ILogonService;

    protected primaryServiceAddress: string;
    protected buddyServiceAddress: string;
    protected showRequestErrorModal: boolean = false;
    protected initialized: boolean = false;
    protected initializing: boolean = false;

    protected _serviceAddress: string = null;
    public get serviceAddress(): string {
        return this._serviceAddress;
    }

    public set serviceAddress(v: string) {
        if (v) this.lastActiveAddress = v;
        this._serviceAddress = v;
    }

    public _noSession: boolean = true;
    public get noSession(): boolean {
        return this._noSession;
    }
    public set noSession(value: boolean) {
        this._noSession = value;
    }

    private _token: string = null;
    public get token(): string {
        if (!this._token) {
            this._token = localStorage.getItem('jwtToken');
        }
        return this._token;
    }
    public set token(value: string) {
        this._token = value;
        this.imgServiceWorker.postMessage({ authorization: this._token });
        localStorage.setItem('jwtToken', value);
        if (window?.['webkit']?.messageHandlers?.interOp?.postMessage) {
            window['webkit'].messageHandlers.interOp.postMessage({ name: 'setJWT', jwtToken: this._token });
        }
    }

    public lastActiveAddress: string = null;

    public Navigation: any = null;
    public CustomCardFields: Array<string> = null;

    public HelloResults: HelloResults = null;
    public ClipboardTemplateSourceCountPerType: { [id: number]: number } = {};
    public helloResultsLoadedSource = new Subject<any>();
    public HelloResultsLoadedObservable = this.helloResultsLoadedSource.asObservable();

    public PSTGroup: string;
    public AppTokenId: string = null;
    public NomTokenId: string = null;
    public UserId: string = null;
    public HasSSOProviders: boolean = false;

    public PSTServer: string;
    public PSTHoldFolder: string = 'PST';
    public DiscoverHoldFolder: string = 'DISCOVER';
    public currentPlaybookTeam: string = '';

    public DiscoverAPIBaseUrl: string;
    public ssoProviders: Array<SSOSettings>;
    public ssoConfigSettings: SSOConfigSettings;
    public loginWithSSOprovidersOnly: boolean = true;

    private showErrors: boolean = true;

    // !IMPORTANT: this is the img service worker reference
    public imgServiceWorker: ServiceWorker;

    constructor(
        private http: HttpClient,
        protected router: Router,
        public convertor: Convertor,
        public modalService: ModalService,
        public languageSettings: LanguageSettings
    ) {
        Record.nomWebServicesJson = this;
        FilterKeywords.nomWebServicesJson = this;
        Path.nomWebServicesJson = this;
        ResultGroupStaticServices.nomWebServicesJson = this;
    }

    public initFromEnvironment() {
        this.primaryServiceAddress = environment.service_address;
        this.buddyServiceAddress = environment.backup_service_address;
        this.DiscoverAPIBaseUrl = environment.discover_api_base_url;
        this.showErrors = environment.show_errors;
    }

    public saveNavigationSessionData() {
        localStorage.setItem('Navigation', JSON.stringify(this.Navigation));
    }

    public saveCustomCardFieldsSessionData() {
        localStorage.setItem('CustomCardFields', JSON.stringify(this.CustomCardFields));
    }

    public saveDesktopMode(mode: boolean) {
        localStorage.setItem('DesktopMode', JSON.stringify(mode));
    }

    public saveSessionData() {
        localStorage.setItem('SessionUserId', this.UserId);
        localStorage.setItem('SessionNomTokenId', this.NomTokenId);
        if (this.HelloResults.Navigation) {
            this.Navigation = this.HelloResults.Navigation;
            this.HelloResults.Navigation = null;
            this.HelloResults.PSTSuiteNavigation = null;
        }
        if (this.HelloResults.CustomCardFields && this.HelloResults.CustomCardFields.length) {
            this.CustomCardFields = this.HelloResults.CustomCardFields;
            this.HelloResults.CustomCardFields = null;
        }
        localStorage.setItem('Navigation', JSON.stringify(this.Navigation));
        localStorage.setItem('CustomCardFields', JSON.stringify(this.CustomCardFields));
        localStorage.setItem('GlobalsHelloResults', JSON.stringify(this.HelloResults));
        localStorage.setItem('HasSSOProviders', `${this.HasSSOProviders}`);
    }

    public clearSessionData() {
        localStorage.removeItem('SessionUserId');
        localStorage.removeItem('SessionNomTokenId');
        localStorage.removeItem('GlobalsHelloResults');
        localStorage.removeItem('Navigation');
        localStorage.removeItem(NAVIGATION_STORAGE_KEY);
        localStorage.removeItem('HasSSOProviders');
        localStorage.removeItem('CustomCardFields');
        localStorage.removeItem('DesktopMode');
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('providerName');
    }

    public searchParams(data: { [id: string]: string }) {
        const ret = new URLSearchParams();
        for (const p in data) ret.set(p, data[p]);
        return ret;
    }

    public async waitForServiceAddress(): Promise<boolean> {
        const start = Date.now();
        while (this.serviceAddress === null) {
            const durationSeconds = (Date.now() - start) / 1000;
            if (durationSeconds >= 10) {
                // Report error if serviceAddress is still null after 10 seconds as we don't want to loop endlessly here
                return false;
            }
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        return true;
    }

    public getDatabase(): string {
        return this.PSTServer;
    }

    public getPath(inTeamSettingsMode = false): string {
        let path = `U_${this.UserId}\\VS`;
        if (inTeamSettingsMode) {
            path = `P_${this.currentPlaybookTeam}\\VS`;
        }
        return path;
    }

    public get isBuddyConfigured(): boolean {
        return this.buddyServiceAddress && this.buddyServiceAddress.toUpperCase() !== 'NONE' && this.buddyServiceAddress.toUpperCase() !== 'CHANGEME';
    }

    protected async isActiveHandler(endPointAddress: string, resolve: (value?: string) => void) {
        try {
            if (endPointAddress !== null) {
                const headers = new HttpHeaders();
                headers.append('Cache-control', 'no-cache');
                headers.append('Cache-control', 'no-store');
                headers.append('Expires', '0');
                headers.append('Pragma', 'no-cache');
                const response = await firstValueFrom(
                    this.http
                        .get<HttpResponse<any>>(`${endPointAddress}/api/IsAlive`, {
                            headers,
                            responseType: 'json',
                            observe: 'response',
                        })
                        .pipe(timeout(5000))
                );
                // 5s timeout
                if (response.ok) {
                    resolve(endPointAddress);
                } else {
                    resolve(null);
                }
            } else {
                resolve(null);
            }
        } catch (e) {
            resolve(null);
        }
    }

    public async isActive(endPointAddress: string, delay?: number): Promise<string> {
        const ret = new Promise<string>(resolve => {
            if (!delay) {
                this.isActiveHandler(endPointAddress, resolve);
            } else {
                setTimeout(() => {
                    this.isActiveHandler(endPointAddress, resolve);
                }, delay);
            }
        });
        return ret;
    }

    public sendServiceData(): void {
        const data = {
            server: encodeURI(this.serviceAddress),
            database: this.HelloResults.HomeDatabase,
            path: `P_${this.PSTGroup}\\`,
            apptoken: this.AppTokenId,
            username: this.HelloResults.UserID,
        };
        if (window?.['webkit']?.messageHandlers?.interOp?.postMessage) {
            window['webkit'].messageHandlers.interOp.postMessage({ name: 'serviceData', url: JSON.stringify(data) });
        } else if (window?.['ANDROID_WRAPPER']?.setLocationParams) {
            window['ANDROID_WRAPPER'].setLocationParams(JSON.stringify(data));
        }
    }

    public async getActiveServiceAddress(): Promise<void> {
        if (!this.isBuddyConfigured) {
            // Use primary
            this.serviceAddress = this.primaryServiceAddress;
        } else {
            // Check both and use the first one which is active. Primary is first in the list so even if buddy replies faster primary will be used
            const results = await Promise.all<string>([this.isActive(this.primaryServiceAddress), this.isActive(this.buddyServiceAddress)]);
            for (const uri of results) {
                if (uri) {
                    this.serviceAddress = uri;
                    return;
                }
            }
            this.serviceAddress = null;
        }
    }

    protected async disconnectRTUHandler() {
        if (!this.isBuddyConfigured) {
            // No buddy configured - loop while primary becomes active again
            let isActive = null;
            do {
                try {
                    isActive = await this.isActive(this.serviceAddress);
                } catch (e) {
                    console.log(e);
                }
                await new Promise(resolve => setTimeout(resolve, 1000));
            } while (!isActive);
        } else {
            // Buddy configured - loop while one of the services becomes active
            this.serviceAddress = null;
            while (this.serviceAddress === null) {
                await this.getActiveServiceAddress();
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }
        // Issue a ping and try to reestablish the session
        const pingRes = await this.ping();
        if (!pingRes.status && (pingRes.message.trim().toLowerCase() === 'invalid session' || pingRes.message.trim().toLowerCase() === 'ping failed')) {
            // Ping failed - redirect to logon
            Util.saveWarningError(this.languageSettings.PSTWebSessionExpiredMessage);
            this.logonService.password = '';
            this.clearSessionData();
            this.router.navigate(['/login']);
        } else if (pingRes.status) {
            // Ping succeeded - reconnect signalR and resubscribe
            this.sendServiceData();
            await DataStore.realtimeUpdatesProviders.enps.connectV2(this.serviceAddress, rec => {
                this.rtuHandler(rec);
            });
            for (const subscriptionId in DataStore.rtuSubscriptions) {
                await DataStore.realtimeUpdatesProviders.enps.subscribe(subscriptionId);
            }
        }
    }

    public async connectRTU() {
        try {
            await DataStore.realtimeUpdatesProviders.enps.connectV2(this.serviceAddress, rec => {
                this.rtuHandler(rec);
            });
            await DataStore.realtimeUpdatesProviders.enps.registerDisconnectHandler(this.disconnectRTUHandler.bind(this));
        } catch (err) {
            Util.saveWarningError(`Failed to connect to realtime updates! rStackTrace: NomWebServicesJson.connectRTU(); Error:${err.toString()}`);
        }
    }

    private rtuHandler(rec: StorytellingRecord) {
        const cleanupStory = (storyRecord: StorytellingStoryRecord) => {
            if (storyRecord.Type === ObjectTypes.SCRIPT) {
                if (storyRecord.EditLocked && storyRecord.EditLockedBy === this.UserId) {
                    delete storyRecord.Text;
                    delete storyRecord.TextCommands;
                    delete storyRecord.text;
                }
                if (storyRecord.Title == null) {
                    delete storyRecord.Title;
                }
            }
        };
        switch (rec.Type) {
            case ObjectTypes.TOPIC:
                this.store.dispatch(TopicRecordActions.updateTopics({ records: [rec] }));
                break;
            case ObjectTypes.ASSIGNMENT:
                this.store.dispatch(AssignmentRecordActions.updateAssignments({ records: [rec] }));
                break;
            case ObjectTypes.SCRIPT:
                cleanupStory(rec);
                this.store.dispatch(StoriesRecordActions.updateStories({ records: [rec] }));
                break;
            case ObjectTypes.RUNDOWN: {
                this.store.dispatch(RundownRecordActions.updateRundowns({ records: [rec] }));
                const children = (rec as StorytellingRundownRecord).children.map(child => {
                    cleanupStory(child);
                    return child;
                });
                this.store.dispatch(StoriesRecordActions.updateStories({ records: children }));
                this.store.dispatch(StoriesRecordActions.fixMovedStory({ record: rec as StorytellingRundownRecord }));
                break;
            }
            case ObjectTypes.PUBLICATIONLIST:
                this.store.dispatch(PublicationRecordActions.updatePublicationList({ records: [rec] }));
                break;
            case ObjectTypes.PUBLICATION_CHANNEL:
                this.store.dispatch(PublicationRecordActions.updatePublicationChannels({ records: [rec] }));
                break;
            case ObjectTypes.PUBLICATION:
                this.store.dispatch(PublicationRecordActions.updatePublications({ records: [rec] }));
                break;
            default:
                break;
        }
    }

    public async ping(): Promise<ServiceResponse<void>> {
        try {
            await this.getActiveServiceAddress();
            const response = await this.get('/api/Ping', {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.NomTokenId || '',
                }),
                responseType: 'json',
                observe: 'response',
            });
            if (response.ok) {
                // if (!this.initialized) await this.init();
                return new ServiceResponse<void>(true);
            }
            if (response.status === 401) {
                Util.saveWarningError('Ping() failed: Invalid session');
                this.clearSessionData();
                this.destroySession();
                return new ServiceResponse<void>(false, 'Invalid session');
            }
            return new ServiceResponse<void>(false, 'Ping failed');
        } catch (e) {
            return new ServiceResponse<void>(false, 'Ping failed');
        }
    }

    public async getSuggestions(query: string): Promise<ServiceResponse<Array<string>>> {
        if (query.trim().length > 0) {
            const requestParams = {
                Query: query,
            };
            let response: HttpResponse<any> = null;
            try {
                response = await this.get('/api/Suggest', {
                    headers: new HttpHeaders({
                        'Content-Type': 'application/json',
                        'X-ENPS-TOKEN': this.NomTokenId,
                    }),
                    responseType: 'json',
                    params: requestParams,
                    observe: 'response',
                });
            } catch (error) {
                Util.saveWarningError(`Failed to load tags! StackTrace: NomWebServicesJson.getSuggestions(); Error:${error.toString()}`);
                return new ServiceResponse<Array<string>>(true, []);
            }
            return new ServiceResponse<Array<string>>(true, response.body);
        }
        return new ServiceResponse<Array<string>>(true, []);
    }

    public getUploadEndPoint(): string {
        return `${this.serviceAddress}/api/Avatar`;
    }
    public getAvatarEndPoint(token: string) {
        token = this._token;
        return token;
    }
    public getAttachmentEndPoint(): string {
        return `${this.serviceAddress}/api/BasicContent`;
    }

    public getAvatarImageUrl(userId: string): string {
        return `${this.lastActiveAddress}/api/Avatar?userid=${userId}&userToken=${this.token}`;
    }

    // Error modal
    public showErrorModal(modalInfo: { title?: string; message: string; detailMessage?: string }, errorType: string = ErrorTypes.ERROR) {
        if (this.showErrors) {
            if (!modalInfo.title) {
                if (errorType === ErrorTypes.WARNING) {
                    modalInfo.title = 'Warning';
                } else {
                    modalInfo.title = 'Error';
                }
            }

            if (errorType === ErrorTypes.WARNING) {
                this.modalService.openServiceErrorModal(modalInfo);
            } else {
                const fatalModalInfo = { title: modalInfo.title, message: modalInfo.message, detailedMessage: modalInfo.detailMessage || modalInfo.message };
                this.modalService.openServiceFatalErrorModal(fatalModalInfo);
            }
        }
    }

    public showLockScreenError(err: HttpErrorResponse) {
        if (err && err.status && err.status === 409) {
            // show modal
            this.modalService.openAlert(this.languageSettings.PSTSystemConfiguration, err?.error?.message);
        }
    }

    public async copyENPSObject(
        sourceDatabase: string,
        sourcePath: string,
        sourceGuid: string,
        sourceType: ObjectTypes,
        destinationDatabase: string,
        destinationPath: string,
        destinationType: ObjectTypes,
        propertiesOverride: Array<{ FieldName: string; FieldValue: any }>
    ): Promise<ServiceResponse<StorytellingTopicRecord>> {
        let requestParams = {};
        let response: HttpResponse<any> = null;
        try {
            requestParams = {
                SourceDatabase: sourceDatabase,
                SourcePath: sourcePath,
                SourceGuid: sourceGuid,
                SourceType: sourceType,
                DestinationDatabase: destinationDatabase,
                DestinationPath: destinationPath,
                DestinationType: destinationType,
                PropertiesOverride: propertiesOverride,
            };

            response = await this.post('/api/CopyENPSObject', requestParams, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
        } catch (error) {
            this.showErrorModal({
                message: 'Unable to copy object',
                detailMessage: `Unable to copy object!. \n\rStackTrace: NomWebServicesJson.copyENPSObject(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingTopicRecord>(false, `Unable to create topic ${error.toString()}`);
        }

        const serviceRecord = ServiceCollectionRecord.instance(response.body);
        serviceRecord.instantiateChildren();
        const topicRecord = this.convertor.fromServiceCollectionRecordV2<StorytellingTopicRecord>(serviceRecord);
        // await DataStore.setCollection(topicRecord, true);
        return new ServiceResponse<StorytellingTopicRecord>(true, topicRecord);
    }

    public async copyScriptToCollection(
        collectionDatabase: string,
        collectionPath: string,
        collectionGuid: string,
        destinationType: ObjectTypes,
        sourceDatabase: string,
        sourcePath: string,
        sourceGuid: string,
        sourceType: ObjectTypes,
        propertiesOverride?: Array<{ FieldName: string; FieldValue: any }>
    ): Promise<ServiceResponse<StorytellingAssignmentRecord>> {
        let requestParams = {};
        let response: HttpResponse<any> = null;
        try {
            requestParams = {
                RODatabase: collectionDatabase,
                ROPath: collectionPath,
                ROGuid: collectionGuid,
                DestinationType: destinationType,
                ScriptDatabase: sourceDatabase,
                ScriptPath: sourcePath,
                ScriptGuid: sourceGuid,
                SourceType: sourceType,
                PropertiesOverride: propertiesOverride || null,
            };

            response = await this.post('/api/CopyScriptToCollection', requestParams, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'X-ENPS-TOKEN': this.NomTokenId,
                }),
                responseType: 'json',
                observe: 'response',
            });
        } catch (error) {
            this.showErrorModal({
                message: 'Unable to copy script to collection',
                detailMessage: `Unable to copy object!. \n\rStackTrace: NomWebServicesJson.copyScriptToCollection(); \n\rError: ${error}`,
            });
            return new ServiceResponse<StorytellingAssignmentRecord>(false, `Unable to create assignment ${error.toString()}`);
        }

        if (response.body['Stories']) {
            const objectProperties = new ObjectProperties(response.body.Stories[0]);
            const record = initializeRecord(ObjectTypes.ASSIGNMENT);
            // const record = RecordFactory.createRecordForType(ObjectTypesEnum.ASSIGNMENT);
            this.convertor.deserializeV2(record, objectProperties);
            // await DataStore.set(record);
            return new ServiceResponse<StorytellingAssignmentRecord>(true, record);
        }
        response.body;
        return new ServiceResponse<StorytellingAssignmentRecord>(false, `Unexpected response in create assignment call${response.body.toString()}`);
    }

    public destroySession() {
        this._token = null;
        localStorage.removeItem('jwtToken');
        if (window?.['webkit']?.messageHandlers?.interOp?.postMessage) {
            window['webkit'].messageHandlers.interOp.postMessage({ name: 'setJWT', jwtToken: null });
        }
    }

    public async get<T>(
        url: string,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<T>> {
        return this.executeWithFailoverRetry<HttpResponse<T>>(async () => firstValueFrom(this.http.get<T>(this.serviceAddress + url, options)));
    }

    public async getBlob(
        url: string,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            context?: HttpContext;
            observe?: 'body';
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType: 'blob';
            withCredentials?: boolean;
        }
    ): Promise<Blob> {
        return this.executeWithFailoverRetry<Blob>(async () => firstValueFrom(this.http.get(this.serviceAddress + url, options)));
    }

    public async getText(
        url: string,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            context?: HttpContext;
            observe?: 'body';
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType: 'text';
            withCredentials?: boolean;
        }
    ): Promise<string> {
        return this.executeWithFailoverRetry<string>(async () => firstValueFrom(this.http.get(this.serviceAddress + url, options)));
    }

    public async put<T = unknown>(
        url: string,
        body: any | null,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<T>> {
        return this.executeWithFailoverRetry<HttpResponse<T>>(async () => firstValueFrom(this.http.put<T>(this.serviceAddress + url, body, options)));
    }

    public async post<T>(
        url: string,
        body: any | null,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<T>> {
        return this.executeWithFailoverRetry<HttpResponse<T>>(async () => firstValueFrom(this.http.post<T>(this.serviceAddress + url, body, options)));
    }

    public async delete<T = unknown>(
        url: string,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
            body?: any | null;
        }
    ): Promise<HttpResponse<T>> {
        return this.executeWithFailoverRetry<HttpResponse<T>>(async () => firstValueFrom(this.http.delete<T>(this.serviceAddress + url, options)));
    }

    public async patch<T>(
        url: string,
        body: any | null,
        options?: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<T>> {
        return this.executeWithFailoverRetry<HttpResponse<T>>(async () => firstValueFrom(this.http.patch<T>(this.serviceAddress + url, body, options)));
    }

    protected async executeWithFailoverRetry<T>(f: () => Promise<T>): Promise<T> {
        try {
            if (this.serviceAddress !== null) {
                return await f();
            }
            throw 'Web services not accessible';
        } catch (e) {
            if (this.isBuddyConfigured) {
                // Check if service is active
                if (!(await this.isActive(this.serviceAddress))) this.serviceAddress = null;
                // Attempt to failover proactively
                await this.getActiveServiceAddress();
                if (this.serviceAddress === null) throw 'Web services not accessible';
                return await f();
            }
            throw e;
        }
    }

    public discoverServiceGet<T>(
        url: string,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Observable<HttpResponse<T>> {
        return this.http.get<T>(url, options);
    }

    public discoverServicePost<T>(
        url: string,
        body: any | null,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Observable<HttpResponse<T>> {
        return this.http.post<T>(url, body, options);
    }

    public discoverServicePut<T>(
        url: string,
        body: any | null,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Observable<HttpResponse<T>> {
        return this.http.put<T>(url, body, options);
    }

    public discoverServiceDelete<T>(
        url: string,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Observable<HttpResponse<T>> {
        return this.http.delete<T>(url, options);
    }

    public async discoverAPIGet(
        url: string,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<unknown>> {
        return this.executeWithFailoverRetry<HttpResponse<unknown>>(async () => firstValueFrom(this.http.get(url, options)));
    }

    public async discoverAPIPost(
        url: string,
        body: any | null,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<unknown>> {
        return this.executeWithFailoverRetry<HttpResponse<unknown>>(async () => firstValueFrom(this.http.post(url, body, options)));
    }

    public async discoverAPIDelete(
        url: string,
        options: {
            headers?:
                | HttpHeaders
                | {
                      [header: string]: string | string[];
                  };
            observe: 'response';
            context?: HttpContext;
            params?:
                | HttpParams
                | {
                      [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
                  };
            reportProgress?: boolean;
            responseType?: 'json';
            withCredentials?: boolean;
        }
    ): Promise<HttpResponse<unknown>> {
        return this.executeWithFailoverRetry<HttpResponse<unknown>>(async () => firstValueFrom(this.http.delete(url, options)));
    }

    public getDiscoverPermissions(): DiscoverSecurityPrivs {
        const discoverPermissions = new DiscoverSecurityPrivs();

        try {
            // TODO: Make a Type that extends JWTPayload
            const decodedToken = jwtDecode(this.token);
            const permissionsJson = decodedToken['claims'];

            discoverPermissions.setPermissions(permissionsJson);
        } catch (e) {
            console.error(e);
        }

        return discoverPermissions;
    }
}
